import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  error: null,
  contentAnalytics: null,
  contentDetails: [],
  contentDetailsMeta: { totalRecords: 0 },
  viewsAnalytics: null,
  viewsTrending: null,
  viewsDetails: [],
  viewsDetailsMeta: { totalRecords: 0 },
};

const entityAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.READ_ENTITY_CONTENT_ANALYTICS_REQUEST:
    case actionTypes.READ_ENTITY_CONTENT_DETAILS_REQUEST:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_REQUEST:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_REQUEST:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.READ_ENTITY_CONTENT_ANALYTICS_SUCCESS:
      return { ...state, loading: false, contentAnalytics: action.payload || null };

    case actionTypes.READ_ENTITY_CONTENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        contentDetails: action.payload?.data || [],
        contentDetailsMeta: {
          totalRecords: action.payload?.totalRecords || 0,
        },
      };

    case actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_SUCCESS:
      return { ...state, loading: false, viewsAnalytics: action.payload || null };

    case actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_SUCCESS:
      return { ...state, loading: false, viewsTrending: action.payload || null };

    case actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        viewsDetails: action.payload?.data || [],
        viewsDetailsMeta: {
          totalRecords: action.payload?.totalRecords || 0,
        },
      };

    case actionTypes.READ_ENTITY_CONTENT_ANALYTICS_FAILURE:
    case actionTypes.READ_ENTITY_CONTENT_DETAILS_FAILURE:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_FAILURE:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_FAILURE:
    case actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default entityAnalyticsReducer;
